<div class='RegisterStepReceipt'>
  <div class='container py-3'>
    <div class='RegisterStepReceipt-header row'>
      <div class='col col-12 d-flex flex-row justify-content-between'>
        <span
          class='text-center text-sm-right mb-0'><strong>Name of Card:</strong> {{ paymentData.payment_data.card_name }}</span>
        <span
          class='text-center text-sm-right mb-0'><strong>Brand: </strong>{{ paymentData.payment_data.card_brand }}</span>
        <span class='text-center text-sm-right mb-0'><strong>Card Number:</strong> {{ generateCardNumber() }}</span>
      </div>
    </div>
  </div>
  <div class='RegisterStepReceipt-details w-100 py-5'>
    <div class='RegisterStepReceipt-details-container container py-5'>
      <div class='RegisterStepReceipt-details-container-header row-fluid'>
        <h3>Plan Details</h3>
      </div>
      <div class='RegisterStepReceipt-details-container-body row-fluid pt-0 pt-sm-3'>
        <div class='col col-12'>
          <div class='d-flex flex-column flex-sm-row'>
            <div class='flex-grow-1'>
              <div class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Name: </strong>{{ paymentData.payment_data.product_name }}</p>
              </div>
              <div *ngIf="paymentData.payment_data.applied_team_code" class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Applied code: </strong>{{ paymentData.payment_data.applied_team_code }}</p>
              </div>
              <div class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Price: </strong>${{ paymentData.payment_data.subscription_cost }}
                  /{{ paymentData.payment_data.subscription_period }}</p>
              </div>
              <div *ngIf='paymentData.payment_data?.subscription_discount'
                   class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Subscription discount: </strong><span
                  *ngIf='!paymentData.payment_data.discount_percentage'>$</span>{{ paymentData.payment_data.subscription_discount }}
                  <span *ngIf='paymentData.payment_data.discount_percentage'>%</span>
                </p>
              </div>
              <div *ngIf='paymentData.payment_data?.discount'
                   class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Discounted Subscription Price: </strong>
                  <span
                    *ngIf='!paymentData.payment_data.discount_percentage'>{{ toFloat(toInt(paymentData.payment_data.subscription_cost) - toInt(paymentData.payment_data.discount)) }}
                    $</span>
                  <span
                    *ngIf='paymentData.payment_data.discount_percentage'>{{ toFloat(toInt(paymentData.payment_data.subscription_cost) - ((toInt(paymentData.payment_data.discount) * toInt(paymentData.payment_data.subscription_cost)) / 100)) }}
                    $</span>
                </p>
              </div>
              <div class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Setup fee: </strong>${{ paymentData.payment_data.setup_cost }}</p>
              </div>
              <div *ngIf='paymentData.payment_data?.setup_discount'
                   class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Setup discount: </strong><span
                  *ngIf='!paymentData.payment_data.setup_discount_percentage'>$</span>{{ paymentData.payment_data.setup_discount }}
                  <span *ngIf='paymentData.payment_data.setup_discount_percentage'>%</span>
                </p>
              </div>
              <div *ngIf='paymentData.payment_data?.setup_discount'
                   class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Discounted Setup Fee: </strong>
                  <span
                    *ngIf='!paymentData.payment_data.setup_discount_percentage'>{{ toFloat(toInt(paymentData.payment_data.setup_cost) - toInt(paymentData.payment_data.setup_discount)) }}
                    $</span>
                  <span
                    *ngIf='paymentData.payment_data.setup_discount_percentage'>{{ toFloat(toInt(paymentData.payment_data.setup_cost) - ((toInt(paymentData.payment_data.setup_discount) * toInt(paymentData.payment_data.setup_cost)) / 100)) }}
                    $</span>
                </p>
              </div>
              <div class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3'>
                <p class='text-left'><strong>Email: </strong>{{ paymentData.payment_data.client_email }}</p>
              </div>
              <div class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-4'>
                <p class='text-left'><strong>Contacts limit: </strong>{{ paymentData.payment_data.contacts_limit }}</p>
              </div>
              <div class='RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-4'>
                <p class='text-left'><strong>Emails per day: </strong>{{ paymentData.payment_data.send_limit }}</p>
              </div>
            </div>
            <div class='flex-grow-1'>
              <div *ngIf='paymentData.payment_data.payment_amount'
                   class='RegisterStepReceipt-details-container-body-row d-block pt-3'>
                <p class='text-left'><strong>One Time Fee: </strong>{{ paymentData.payment_data.payment_amount }}</p>
              </div>
              <div *ngIf='paymentData.payment_data.payment_recurring'
                   class='RegisterStepReceipt-details-container-body-row d-block pt-4'>
                <p class='text-left'><strong>Recurring Fee: </strong>{{ paymentData.payment_data.payment_recurring }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class='RegisterStepReceipt-info w-100 py-5'>
    <div class='container'>
      <div class='d-flex flex-row flex-sm-row justify-content-between'>
        <div class='d-flex flex-column flex-sm-column align-bottom'>
          <p><strong>Address: </strong>3767 Attucks Drive Powell, OH 43065</p>
          <p><strong>Phone: </strong>614.902.3400</p>
          <p class='mb-0'><strong>Email: </strong>help@retreva.com</p>
        </div>
        <div class='d-flex flex-column flex-sm-column align-bottom'>
          <p><strong>Customer
            Name: {{ paymentData.payment_data.client_first_name }} {{ paymentData.payment_data.client_last_name }}</strong>
          </p>
          <p><strong>Address: </strong>{{ paymentData.payment_data.client_address }}</p>
          <p><strong>Phone: </strong>{{ paymentData.payment_data.client_phone }}</p>
          <p class='mb-0'><strong>Email: </strong>{{ paymentData.payment_data.client_email }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class='row-fluid pt-5'>
    <div class='col col-12'>
      <app-button [Click]='onContinue' [color]="'orange'" [size]="'normal'" [style]="'rounded'"
                  [text]="'Continue'"></app-button>
    </div>
  </div>
</div>
